import { useEffect } from "react";
import { useRecoilState } from "recoil";
import { nextOpenAtom } from './atoms';
import { getterSetter } from './interfaces';

type localParams = 'nextOpen'
interface Params {
    nextOpen: getterSetter;
}
const defaultNextOpen = 1;

export default function useLocal(param: localParams): getterSetter {
    const [nextOpen, setNextOpen] = useRecoilState(nextOpenAtom);

    useEffect(() => {
        setNextOpen(parseInt(localStorage.getItem('nextOpen') || `${defaultNextOpen}`));
    }, [nextOpen]); // eslint-disable-line react-hooks/exhaustive-deps

    const funcs: Params = {
        nextOpen: [nextOpen, (val) => {
            localStorage.setItem('nextOpen', `${val}`);
            setNextOpen(val);
        }],
    };

    return funcs[param];
}
